import classNames from 'classnames';
import React from 'react';
import { PlaylistItem, videoDetails } from 'packages/common/types/playlist';

import styles from './CollapsibleText.module.scss';
import { useTheme } from '../../../../../ThemeContext';

type Props = {
  text: string;
  className?: string;
  maxHeight?: 'none' | number;
  maxWords?: number;
  showMoreClickHandler?: () => void;
  isHubContent?: boolean;
  item: PlaylistItem | videoDetails;
};

const CollapsibleText: React.FC<Props> = ({ text, item, className, maxHeight = 'none', maxWords = 35, showMoreClickHandler, isHubContent }: Props) => {
  const getTruncatedText = (inputText: string, wordLimit: number) => {
    const words = inputText.split(' ');
    const isTrancated = words.length > wordLimit
    const truncated = words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : inputText;
    return {truncated, isTrancated}
  };
  const { universalStyles, themeConfig } = useTheme();
  const hasText = text == '' || text == undefined || text == null;

  const {truncated, isTrancated} = getTruncatedText(text, maxWords);
  const ismaxWordsExceeds = !hasText ? text.split(' ').length > maxWords : false;
  const isShowMoreButton = (isHubContent && hasText) || (isHubContent && !isTrancated);
  const isShowMoreIsmaxWordsExceeds = isHubContent && isTrancated;

  const allEmpty = ([item.audio_language, item.sub_title, item.cast, item.director, item.producer, item.studio] as (string | undefined | null)[]).every(
    (value) => !value || value.trim() === '',
  );

  return (
    <div className={classNames(styles.collapsibleText)}>
      <p className={styles.textContainer} style={universalStyles.videoDetailsDescription}>
        <span>
          {truncated}
          {!allEmpty || ismaxWordsExceeds ? (
      !isHubContent || !isShowMoreButton || isShowMoreIsmaxWordsExceeds ? (
        <span className={styles.toggleText}  onClick={showMoreClickHandler} role="button" tabIndex={0} style={{ color: themeConfig.primary }}>
          More
        </span>
      ) : null
    ) : null}
        </span>
      </p>
        
    </div>
  );
};

export default CollapsibleText;
